import { createStyles, makeStyles } from "@material-ui/core";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { ColumnModel, PageInfoModel } from "../../../models/common.model";
import { GetSettlementRequestHistoryResponse } from "../../../models/settlement.model";
import { useDispatch, useSelector } from "react-redux";
import {
  getTablePage,
  getTableSelectedRow,
} from "../../../redux/table/tableSlice";

const columns: readonly ColumnModel[] = [
  { id: "settlementType", label: "نوع تسویه" },
  { id: "creatorName", label: "ثبت کننده" },
  { id: "createDatePersian", label: "تاریخ ثبت" },
  {
    id: "totalAmount",
    label: "مبلغ فاکتور (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
  {
    id: "settlementAmount",
    label: "مبلغ تسویه (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
  { id: "confirmerName", label: "تایید کننده" },
  { id: "confirmDatePersian", label: "تاریخ تایید" },
  { id: "sayadNumber", label: "شماره صیادی" },
  { id: "chequeSeri", label: "سری / سریال چک" },
  { id: "transactionNumber", label: "شماره تراکنش آنلاین" },
  { id: "creatorDescription", label: "توضیحات ثبت کننده" },
  { id: "confirmerDescription", label: "توضیحات تایید کننده" },
];

interface Props {
  settlementHistoryList: GetSettlementRequestHistoryResponse[];
  pageInfo: PageInfoModel;
  setCurrentPaginationInfo: (page: any) => void;
  currentPaginationInfo: any;
}
const nextIcon = () => {
  return (
    <img
      style={{ height: "12px", width: "10px" }}
      src="images/Next.png"
      alt=""
    />
  );
};
const previusIcon = () => {
  return (
    <img
      style={{ height: "12px", width: "10px" }}
      src="images/Previous.png"
      alt=""
    />
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: "#CEE5D3 !important",
      },
    },
  })
);

const SettlementHistoryTable = ({
  settlementHistoryList,
  pageInfo,
  currentPaginationInfo,
  setCurrentPaginationInfo,
}: Props) => {
  const classes = useStyles();
  const history = useHistory<{
    settlementData?: {
      saleKey?: string;
      key: string;
      branchId?: number;
      customerPersonId?: number;
    };
  }>();

  const dispatch = useDispatch();
  const tableInfo = useSelector((state: any) => state.table);

  // handlers
  const changePageNumber = (newPageNumber: number) => {
    setCurrentPaginationInfo({
      pageNumber: newPageNumber,
      pageSize: 10,
    });
  };
  const handleClick = (key: string, rowIndex: number) => {
    dispatch(
      getTableSelectedRow({
        selectedRowNum: rowIndex,
      })
    );
    history.push({
      pathname: "/settlementHistoryDetail",
      state: {
        settlementData: { key: key },
      },
    });
    localStorage.setItem(
      "SETTLEMENT_REQUEST_DATA",
      JSON.stringify({ key: key })
    );
  };
  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);

    dispatch(
      getTableSelectedRow({
        selectedRowNum: 0,
      })
    );
    dispatch(
      getTablePage({
        selectedPageNum: value,
      })
    );
  };

  useEffect(() => {
    if (history.action === "POP") {
      setCurrentPaginationInfo({
        pageNumber: tableInfo.selectedPageNum,
        pageSize: 10,
      });
    }
  }, [history.action, setCurrentPaginationInfo, tableInfo.selectedPageNum]);

  return (
    <div>
      <div>
        <div className="cardTableBorder">
          <TableContainer
            style={{ background: "#fff", maxHeight: "55vh" }}
            className="boxScroll"
          >
            <Table
              stickyHeader
              aria-label="sticky table"
              style={{ borderCollapse: "collapse" }}
            >
              <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
                <TableRow
                  classes={{ root: classes.select }}
                  className={`${classes} borderRight borderLeft`}
                  selected={tableInfo.selectedRowNum}
                >
                  {columns.map((column) => (
                    <TableCell
                      className="rowTHead colorTitle textFont12 fontWeight noWrap"
                      key={column.id}
                      align="right"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <div style={{ width: "100%", height: "10px" }}></div>
              <TableBody>
                {settlementHistoryList
                  ? settlementHistoryList?.map((row, rowIndex) => {
                      return (
                        <TableRow
                          classes={{ root: classes.select }}
                          className={`${
                            rowIndex % 2 === 0 ? "rowTBodyE  " : "rowTBodyO "
                          } ${classes} borderRight borderLeft cursorPointer noWrap`}
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.key}
                          selected={tableInfo.selectedRowNum === rowIndex}
                          onClick={() => handleClick(row.key, rowIndex)}
                        >
                          {columns.map((column) => {
                            const value =
                              row[
                                column.id as keyof GetSettlementRequestHistoryResponse
                              ];
                            return (
                              <>
                                {column.id !== "chequeSeri" ? (
                                  <TableCell
                                    className="textFont12"
                                    key={column.id}
                                    align="right"
                                  >
                                    {!value ? (
                                      <>--</>
                                    ) : column.format && column.hasFormat ? (
                                      column.format(value)
                                    ) : (
                                      value?.toString()
                                    )}
                                  </TableCell>
                                ) : (
                                  <TableCell
                                    className="textFont12"
                                    key={column.id}
                                    align="right"
                                  >
                                    {!value ? (
                                      <>--</>
                                    ) : (
                                      value?.toString() +
                                      " / " +
                                      row.chequeSerial
                                    )}
                                  </TableCell>
                                )}
                              </>
                            );
                          })}
                        </TableRow>
                      );
                    })
                  : null}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div>
          <Grid container spacing={2} alignItems="center">
            <Grid
              item
              xs={12}
              sm={4}
              display="flex"
              justifyContent={{ xs: "center", sm: "flex-start" }}
            >
              <span
                style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
              >
                تعداد کل :
                <span style={{ color: "#01AF43" }}>{pageInfo.total}</span> مورد
              </span>
            </Grid>
            <Grid item xs={12} sm={4} display="flex" justifyContent="center">
              <Pagination
                renderItem={(item) => (
                  <PaginationItem
                    components={{
                      previous: previusIcon,
                      next: nextIcon,
                    }}
                    {...item}
                  />
                )}
                // color="primary"
                sx={{
                  direction: "ltr",
                  margin: "5px",
                  button: {
                    color: "#25D1C9",
                    fontSize: "14px !important",
                    fontFamily: "iranSans",
                  },
                  //  button.sele
                }}
                count={
                  pageInfo ? Math.ceil(pageInfo.total / pageInfo.pageSize) : 0
                }
                onChange={handleChangePagination}
                page={currentPaginationInfo.pageNumber}
              />
            </Grid>
            <Grid item xs={12} sm={4}></Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default SettlementHistoryTable;
